<template>
  <div class="main_content_box notify">
    <div class="main_content_card">
      <h4 class="card_title">
        <img src="@/assets/img/title_border.png">
        绿孔雀照片审核记录
      </h4>
      <div class="filter_block">
        <div class="flex_item">
          <span>县市：</span>
          <b-form-select
            v-model="params.county_code"
            :options="countyOptions"
            class="select_group"></b-form-select>
        </div>
        <div class="flex_item">
          <span>片区：</span>
          <b-form-select v-model="params.town_code" :options="placeOptions" class="select_group"></b-form-select>
        </div>
        <div class="flex_item">
          <span>类型：</span>
          <b-form-select v-model="params.animal_type" :options="animalTypesOption" class="select_group"></b-form-select>
        </div>
        <!--<div class="flex_item">-->
          <!--<span>性别：</span>-->
          <!--<b-form-select v-model="params.animal_gender" :options="animalGendersOption" class="select_group"></b-form-select>-->
        <!--</div>-->
        <div class="flex_item" v-if="deviceType !== 'mobile'">
          <span>时间：</span>
          <date-picker v-model="params.start_date" width='160' style="vertical-align: middle;"
                       input-class="select_group mx-input">
            <template slot="calendar-icon">
              <font-awesome-icon icon="chevron-down"/>
            </template>
          </date-picker>
          <span style="padding-right:10px;padding-left:10px">至</span>
          <date-picker v-model="params.end_date" style="vertical-align: middle;" width='160'
                       input-class="select_group mx-input">
            <template slot="calendar-icon">
              <font-awesome-icon icon="chevron-down"/>
            </template>
          </date-picker>
        </div>
        <div class="flex_item" v-if="deviceType === 'mobile'">
          <span>时间：</span>
          <date-picker v-model="params.start_date" width='160' style="vertical-align: middle;"
                       input-class="select_group mx-input">
            <template slot="calendar-icon">
              <font-awesome-icon icon="chevron-down"/>
            </template>
          </date-picker>
        </div>
        <div class="flex_item" v-if="deviceType === 'mobile'">
          <span style="padding-right:10px;padding-left:10px">&nbsp;&thinsp;至</span>
          <date-picker v-model="params.end_date" style="vertical-align: middle;" width='160'
                       input-class="select_group mx-input">
            <template slot="calendar-icon">
              <font-awesome-icon icon="chevron-down"/>
            </template>
          </date-picker>
        </div>

        <div class="flex_item">
          <button class="primary_btn query-btn" @click="submit">筛选</button>
          <button class="secondary_btn query-btn" @click="reset">重置</button>
          <button class="primary_btn query-btn" @click="exportData">导出</button>
        </div>
      </div>
      <div class="flex-box">
        <div class="table-box">
          <table class="table table-striped table-responsive-sm table-hover green_table table-data">
            <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">市县</th>
              <th scope="col">片区</th>
              <th scope="col">村寨</th>
              <th scope="col">位置</th>
              <th scope="col">动物类型</th>
              <th scope="col">个数</th>
              <th scope="col">动物名</th>
              <th scope="col">性别</th>
              <th scope="col">行为</th>
              <th scope="col">审核人</th>
              <th scope="col">时间</th>
              <th scope="col">操作</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="item in historyItems">
              <tr @click="removeAllSelect();item.selected = true;currentItem = item;"
                  :class="{ 'b-table-row-selected table-success': item.selected }"
                  v-bind:key="item.id">
                <td>{{item.id}}</td>
                <td><div>{{ countyMap[item.county].county_name }}</div></td>
                <td><div>{{ townMap[item.town].town_name }}</div></td>
                <td><div>{{item.village}}</div></td>
                <td><div>{{item.place}}</div></td>
                <td>
                  <b-form-select v-model="item.animal_type" :options="animalTypesOption"/>
                </td>
                <td>
                  <b-input v-model.number="item.animal_count" type="number" style="width: 60px;"/>
                </td>
                <td>
                  <b-form-input v-model="item.animal_name"/>
                </td>
                <td>
                  <div v-for="(v, k) in item.animal_gender" v-bind:key="k" class="gender">
                    <b-input v-model.number="item.animal_gender[k]" type="number"/>
                    <span>{{ animalGendersMap[k] }}</span>
                  </div>
                </td>
                <td>
                  <b-form-input v-model="item.animal_action"/>
                </td>
                <td>{{ item.checker }}</td>
                <td><div class="update-time">{{ item.email_receive_time.substring(5, item.email_receive_time.length - 3) }}</div></td>
                <td>
                  <div><b-link @click.stop="modifyItem(item)">修改</b-link></div>
                </td>
              </tr>
            </template>
            <tr v-show="historyItems.length === 0">
              <td colspan="14" class="text-center">
                <div v-if="querying">查询中...</div>
                <div v-else>未查询到数据</div>
              </td>
            </tr>
            </tbody>
          </table>
          <div class="pagination-box">
            <div class="left">
              每页{{params.page_size}}条，共{{pageNumber}}页/{{total}}条
            </div>
            <b-pagination
              class="right"
              v-model="params.page_no"
              :total-rows="total"
              :per-page="params.page_size"
              @change="submit">
            </b-pagination>
            <div class="right">
              跳转到第
              <b-input
                v-model.number="params.page_no"
                type="number"
                :min="1"
                :max="pageNumber"
                @change="submit"
                style="width: 60px; display: inline-block"/>
              页
            </div>
          </div>
        </div>
        <div class="img-box">
          <div class="img-border">
            <img v-if="!querying" :src="'/data/images/' + currentItem.img_url" width="500px" height="400px">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import DatePicker from 'vue2-datepicker'
import placeApi from '../api/place'
import { getRecords, updateRecord, exportRecords } from '../api/record'

export default {
  data () {
    return {
      deviceType: this.$device.type, // 设备类型 'mobile', 'tablet', 'desktop', or 'unknown'
      params: {
        county_code: null,
        town_code: null,
        animal_type: null,
        animal_gender: null,
        start_date: null,
        end_date: null,
        page_no: 1,
        page_size: 10
      },
      total: 0,
      querying: true,
      countyOptions: [],
      countyMap: {},
      townMap: {},
      historyItems: [],
      currentItem: {}
    }
  },
  components: {
    DatePicker
  },
  computed: {

    // TODO Mix
    animalTypesOption () {
      return this.$store.getters.animal_types.map(item => {
        return { text: item.name, value: item.id }
      })
    },
    animalTypesMap () {
      let types = {}
      this.$store.getters.animal_types.forEach(item => {
        types[item.id] = item.name
      })
      return types
    },
    animalGendersMap () {
      let m = {}
      let list = this.$store.getters.animal_genders
      list.forEach(x => {
        m[x.value] = x.text
      })
      return m;
    },
    placeOptions () {
      let list = this.countyMap[this.params.county_code]
      if (!list) {
        return [];
      } else {
        return list.townList.map(item => {
          return {
            value: item.town_code,
            text: item.town_name
          }
        })
      }
    },
    pageNumber() {
      return Math.ceil(this.total/this.params.page_size);
    }
  },
  created () {
    // this.init();
  },
  mounted () {
    this.init()
  },
  destroyed () {

  },
  methods: {
    init () {
      placeApi.getPlaceMapForRecords().then(m => {
        this.countyMap = m;
        Object.keys(m).forEach(x => {

          m[x].townList.forEach(town => {
            this.townMap[town.town_code] = town
          })

          this.countyOptions.push({
            value: x,
            text: m[x].county_name
          });
        });

        this.getHistoryData(this.params)
      });

    },
    submit (value) {
      this.params.page_no = value
      this.getHistoryData(this.params)
    },
    reset () {
      Object.keys(this.params).forEach(k => this.params[k] = null)
      this.params.page_no = 1;
      this.params.page_size = 10;
      this.placeOptions = []
      this.getHistoryData(this.params)
    },

    removeAllSelect () {
      for (let i = 0; i < this.historyItems.length; i++) {
        this.historyItems[i].selected = false
      }
    },
    modifyItem (item) {
      let params = {
        id: item.id,
        animal_type: item.animal_type,
        animal_name: item.animal_name,
        animal_count: item.animal_count,
        animal_gender: this.animalGenderToString(item),
        animal_action: item.animal_action
      }
      updateRecord(params).then(resp => {
        this.$toasted.global.pop_success('修改成功')
        this.getHistoryData(this.params)
      }).catch(error => {
        this.$toasted.global.pop_error('修改失败')
      })
    },
    exportData () {
      exportRecords(this.params)
    },
    getHistoryData (data) {
      data.start_date = data.start_date ? new Date(data.start_date).format('yyyy-MM-dd') : ''
      data.end_date = data.end_date ? new Date(data.end_date).format('yyyy-MM-dd') : ''
      this.querying = true
      getRecords(data).then(resp => {
        this.querying = false
        this.historyItems = resp.records
        this.historyItems.forEach(obj => {
          obj.selected = false
          obj.animal_gender = this.parseAnimalGender(obj)
        })
        this.total = resp.num || 0;
        this.currentItem = this.historyItems.length ? this.historyItems[0] : {}
      }).catch(error => {
        console.error(error)
        this.$toasted.global.pop_error('获取数据失败')
      })
    },
    parseAnimalGender (record) {
      let str = record.animal_gender;
      let res = {
        0: 0,
        1: 0,
        2: 0,
        3: 0
      };
      if (!str) {
        return res;
      }
      str.split(';').forEach(x => {
        let arr = x.split(':')
        if(arr[1] !== '' && !isNaN(arr[1])) res[arr[0]] = arr[1]
      })
      return res;
    },
    animalGenderToString (record) {
      let obj = record.animal_gender
      return Object.keys(obj).map(x => x + ':' + obj[x]).join(';')
    }
  },
  watch: {}

}
</script>
<style lang="scss">
  .notify {
    .pagination-box {
      overflow: hidden;
      .right {
        float: right;
      }
      .left {
        float: left;
      }
      .pagination {
        margin-bottom: 0;
        margin-left: 20px;
        .page-item {
          .page-link {
            padding: 0 10px;
            border: none;
            background: transparent;
            color: #646464;
          }
          &.active .page-link{
            border: none;
            background: transparent;
            color: #5A8834;
            text-decoration:underline
          }
        }
      }
    }

    /*调整输入框高度，组件不支持这么小*/
    .select_group.custom-select, .table .custom-select {
      height: 22px;
      padding: 0 30px 0 5px;
    }
    .select_group.custom-select {
      width: 160px;
    }
    .form-control {
      height: 22px;
      padding: 0 5px;
      width: 120px;
    }
    .flex_item .mx-input {
      height: 22px;
      padding: 0 30px 0 5px;
      font-size: 12px;
    }
    .mx-input-append {
      padding: 2px 8px;
    }

  }
</style>
<style lang="scss" scoped>
  $img_root_path: '../assets/img/';
  .filter_block {
    margin: 30px 40px;
  }
  .table .custom-select {
    width: 120px;
  }
  .primary_btn, .secondary_btn {
    height: 22px;
  }
  .flex-box {
    padding: 0 40px 30px;
  }
  .table-box {
    overflow-y: auto;
  }
  .img-box {
    width: 530px;
    .img-border {
      background: url($img_root_path + 'img-border.png') no-repeat;
      background-size: cover;
      width: 530px;
      height: 480px;
      padding: 33px 11px 47px 19px;
    }
  }

  @media screen and (min-width: 1080px) {
    .flex-box {
      display: flex;
    }
    .table-box {
      flex: 1;
    }
    .img-box {
      margin-left: 30px;
      min-height: 480px;
      position: relative;
      .img-border {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  @media screen and (min-width: 700px) and (max-width: 1080px) {
    .img-box {
      margin: 0 auto;
    }
  }
  @media screen and (max-width: 700px) {
    .img-box {
      width: 100%;
      height: auto;
      .img-border {
        width: 100%;
        height: auto;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .table.table-data {
    td > div {
      min-width: 40px;

      &.update-time {
        min-width: 80px;
      }
    }

  }

  .gender {
    width: 100px;
    input {
      width: 60px;
      display: inline-block;
      margin-right: 5px;
    }
  }

  .query-btn {
    margin-left:20px;
    vertical-align: middle;
  }


</style>
